import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { getTranslation } from "../../service/service.js";
// import SelectIcon from "../../assets/images/select-language.png";
import ReactCountryFlag from "react-country-flag";
import styles from "./selectedLanguages.module.css";
import { LanguageIcon } from "../../assets/icons/Language.js";

const SelectLanguage = () => {
  const [languages, setLanguages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [languageError, setLanguageError] = useState(false);
  const [region, setRegion] = useState(null);
  const [regionCode, setRegionCode] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user-info")) || {
      data: { available_languages: [] },
    };
    const available_languages = user.data.available_languages;

    // Ordenar as linguagens pelo nome
    const sortedLanguages = available_languages
      .map((item) => ({ ...item, selected: false }))
      .sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

    setLanguages(sortedLanguages);
    setRegion(user.data.region_user);
    setRegionCode(user.data.region_code);
  }, []);

  const selectLanguage = (index) => {
    const updatedLanguages = languages.map((item, i) => ({
      ...item,
      selected: i === index,
    }));
    setLanguages(updatedLanguages);
    setSelectedLanguage(updatedLanguages[index].code);
  };

  const getLanguageFlag = (code) => {
    switch (code) {
      case "en":
        return "us";
      case "pt":
        return "br";
      default:
        return code;
    }
  };

  const setLanguage = () => {
    setIsLoading(true);
    const languageCode =
      region && region !== "BRA" && selectedLanguage === "en"
        ? regionCode
        : selectedLanguage;
    localStorage.removeItem('currentBookId');

    getTranslation(languageCode)
      .then((res) => {
        const language = { ...res.data, selectedLanguage, languageCode };
        localStorage.setItem("languagePack", JSON.stringify(language));
        history.push('/classes/list');
        window.location.reload();
      })
      .catch((err) => {
        console.log("getTranslation error: ", err);
        setLanguageError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onErrorCloseModal = () => {
    const language = { selectedLanguage };
    localStorage.setItem("languagePack", JSON.stringify(language));
    window.location.reload();
  };

  return (
    <>
      <div className={styles.backdrop}>
        <div className={styles.modal}>
          <div className={styles.content}>
            <LanguageIcon className={styles.icon_language} />
            <span className={styles.content_instruction}>
              Selecione o curso abaixo
            </span>
          </div>
          <div className={styles.content_languages_list}>
            {languages.map((item, index) => (
              <div
                className={`${styles.content_languages_item} ${
                  item.selected ? styles.content_languages_item_selected : ""
                }`}
                key={index}
                onClick={() => selectLanguage(index)}
              >
                <ReactCountryFlag
                  svg
                  countryCode={getLanguageFlag(item.code)}
                  className={styles.content_country_flag}
                />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
          <button
            disabled={!selectedLanguage}
            className={styles.select_language_button}
            onClick={setLanguage}
          >
            {isLoading && <div className="spinner-border" role="status"></div>}
            <span>{!isLoading ? "Acessar curso" : ""}</span>
          </button>
          {languageError && (
            <div className={styles.close_modal_content}>
              <div className={styles.error_load_language}>
                Erro ao acessar o curso,
                <br /> selecione outro.
              </div>
              <div onClick={onErrorCloseModal} className={styles.close_modal}>
                Clique aqui para fechar
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SelectLanguage;
